import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';

class ModuleForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSubmit: false,
      data: {
        name: '',
      },
    };
  }

  handleSubmit = async () => {
    const { data } = this.props;
    const { modules } = this.props.subGroup.toJS();
    this.setState({ isSubmit: true });
    const foundEmptyData = modules.find((m) => m.name === '');

    if (!foundEmptyData) {
      await this.props.handleCreate(data.id, modules);
    }
  };

  addModule = () => {
    const { modules } = this.props.subGroup.toJS();
    modules.push(this.state.data);
    this.props.subGroup.setModules(modules);
  };

  handleDelete = (index) => {
    const { modules } = this.props.subGroup.toJS();
    const results = modules.filter((val, i) => i !== index);
    if (results.length === 0) {
      results.push(this.state.data);
    }
    this.props.subGroup.setModules(results);
  };

  handleChangeInput = (key, value, index) => {
    this.setState({ isSubmit: false });
    this.props.subGroup.changeMultipleDataInModule(key, value, index);
  };

  render() {
    const { classes, t } = this.props;
    const { modules } = this.props.subGroup.toJS();
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleCloseForm}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          <Grid container style={{ position: 'relative' }}>
            <div className={classes.textHeader}>{t('wizard_step_module')}</div>
            <div id='closeIcon' className='closeIcon' onClick={this.props.handleCloseForm}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {(modules || []).map((data, index) => (
            <Grid container key={index} style={{ marginBottom: 10 }}>
              <Grid container item md={12} xs={12} alignItems='center' style={{ marginTop: 10, position: 'relative' }}>
                <Typography
                  style={{
                    fontWeight: 500,
                    fontSize: 18,
                  }}
                >
                  {t('wizard_module_name')}*
                </Typography>
                <div id={`delete-${index}`} className={classes.trashIcon} onClick={() => this.handleDelete(index)}>
                  <svg width='16' height='16' viewBox='0 0 16 16'>
                    <use xlinkHref={`/images/menus-v1.svg#trash`} />
                  </svg>
                </div>
              </Grid>
              <Grid item md={12} xs={12}>
                <TextField
                  required
                  id='name'
                  name='name'
                  variant='outlined'
                  margin='dense'
                  fullWidth
                  value={data.name || ''}
                  onChange={(e) => this.handleChangeInput('name', e.target.value, index)}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                />
                <FormHelperText
                  error
                  hidden={this.state.isSubmit && data.name.length === 0 ? false : true}
                  id='component-error-text'
                >
                  {t('required_field')}
                </FormHelperText>
              </Grid>
            </Grid>
          ))}

          <Grid container item md={12} xs={12} alignItems='center'>
            <Button
              id='add-module'
              color='primary'
              style={{ fontSize: 14, fontWeight: 400 }}
              onClick={() => this.addModule()}
            >
              <div style={{ marginRight: 5 }}>
                <svg width='24' height='24' viewBox='0 0 24 24' style={{ fill: '#006469' }}>
                  <use xlinkHref={`/images/menus-v1.svg#add-circle`} />
                </svg>
              </div>
              {t('wizard_add_module_name')}
            </Button>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container style={{ margin: 20, justifyContent: 'right' }}>
            <Button
              id='save'
              variant='contained'
              color='primary'
              className={classes.btnPrimary}
              onClick={() => this.handleSubmit()}
            >
              {t('save')}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  btnPrimary: {
    width: 200,
    borderRadius: '4px',
  },
  textField: {
    fontWeight: 400,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  trashIcon: {
    position: 'absolute',
    right: 14,
    cursor: 'pointer',
    fill: theme.palette.primary.main,
  },
  contactTitle: {
    fontSize: 16,
  },
});

export const page = inject('subGroup')(observer(ModuleForm));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
